import { AnyAction } from "redux";
import { IFetchAction, FetchStatus } from "../middleware/fetch-middleware";

export enum ContentApiActions {
    GetContentProps = 'contentApiActions/getContentProps',
}

export interface ContentApiState<TProps> {
    props: TProps
}

const DefaultContentApiState = {
    props: {}
}

export const contentApiReducerWithDefault = (defaultState: ContentApiState<any>) => (state = defaultState, action: AnyAction) => {
    switch (action.type) {
        case ContentApiActions.GetContentProps + FetchStatus.Complete:
            return { ...state, props: action.data }
        default:
            return state;
    }
}

export const contentApiReducer = contentApiReducerWithDefault(DefaultContentApiState);
const BaseUrl = '/api/v1/content';

export const getContentProps = (contentId: string): IFetchAction => ({
    type: ContentApiActions.GetContentProps,
    fetch: new Request(`${BaseUrl}/properties?contentId=${contentId}&includeGlobalSettingClientProperties=true`)
})